import { useTranslation } from 'react-i18next';
import type { ProjectStatus } from '../../../data/projects';
import styles from './StatusPill.module.css';

type StatusTone = 'default' | 'onMedia';

interface StatusPillProps {
    status: ProjectStatus;
    tone?: StatusTone;
}

export default function StatusPill({ status, tone = 'default' }: StatusPillProps) {
    const { t } = useTranslation();

    return (
        <span className={styles.pill} data-status={status} data-tone={tone}>
            <span className={styles.dot} aria-hidden="true" />
            {t(`status.${status}`)}
        </span>
    );
}
